import PlaylistSharedPage from './PlaylistSharedPage'

export default PlaylistSharedPage
